import { MapArea } from "../entities/MapArea";
import { BaseService } from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class MapAreaService extends BaseService<MapArea> {
  static $inject = ['$http', '$q', '$state'];
  constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
    super($http, $q, $state, MapArea);
  }
  getBaseUrl(): string {
    return "maparea";
  }
  getBySite(siteId: number): ng.IPromise<MapArea[]> {
    var config: any = {};
    return this.useBaseGetArrayHandler(this.getBasesUrl(), "getBySite?siteId=" + siteId, config);
  }
  getUniqueFloorLevel(): ng.IPromise<number> {
    var config: any = {};
    return this.useGetHandler(this.getBaseUrl(), "UniqueFloorLevel", config);
  }
  getByFloorLevel(floorLevel: number): ng.IPromise<MapArea> {
    var config: any = {};
    return this.useBaseGetHandler(this.getBaseUrl(), "FloorLevel?floorLevel=" + floorLevel, config);
  }
}
